var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineNextGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 16,
    viewBox: "0 0 72 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7C0.447715 7 0 7.44772 0 8C0 8.55228 0.447715 9 1 9V7ZM71.7071 8.70711C72.0976 8.31658 72.0976 7.68342 71.7071 7.29289L65.3431 0.928932C64.9526 0.538408 64.3195 0.538408 63.9289 0.928932C63.5384 1.31946 63.5384 1.95262 63.9289 2.34315L69.5858 8L63.9289 13.6569C63.5384 14.0474 63.5384 14.6805 63.9289 15.0711C64.3195 15.4616 64.9526 15.4616 65.3431 15.0711L71.7071 8.70711ZM1 9H71V7H1V9Z",
    fill: "#07D3C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineNextGreen);
export default __webpack_public_path__ + "static/media/lineNextGreen.615c9b7bd2bb705ef018ae590d3a4a24.svg";
export { ForwardRef as ReactComponent };